import { inject } from "mobx-react";
import { useCallback, useEffect, useRef, useState } from "react";
import type { Store } from "@inferno/renderer-shared-core";
import { ILog } from "@ihr-radioedit/inferno-core";
import { LeavingSiteEvent, useNewWindow } from "@inferno/renderer-shared-core";
import { LeavingSiteDataType } from "../../decoders/LeavingSite.types";

import { Modal } from "../../ui";
import { Button, ButtonKind } from "../../ui";
import "./LeavingSite.style.scss";

const log = ILog.logger("LeavingSite.component");

interface LeavingSiteProps {
  feedData: LeavingSiteDataType;
  store?: Store;
}

export const LeavingSite = inject("store")((props: LeavingSiteProps) => {
  const { store } = props;
  const [isOpen, setIsOpen] = useState(false);
  const outboundUrlRef = useRef("");

  const { title, subtitle } = props.feedData;

  const handlesUserDismiss = useCallback(() => {
    log.debug("Close warning modal");
    setIsOpen(false);
  }, [setIsOpen]);

  const handleClick = useCallback(
    (evt: LeavingSiteEvent) => {
      const { url, type, action } = evt;
      if (action === "click" && type?.toString() === "link_warning" && url) {
        log.debug("Open warning modal");
        outboundUrlRef.current = url;
        setIsOpen(true);
      }
    },
    [setIsOpen, outboundUrlRef],
  );

  useEffect(() => {
    store?.onAnalyticsAction.subscribe(handleClick);
    return () => store?.onAnalyticsAction.unsubscribe(handleClick);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [openWindow] = useNewWindow();

  const confirm = useCallback(() => {
    if (outboundUrlRef.current) {
      openWindow({ url: outboundUrlRef.current, target: "_blank" });
      setIsOpen(false);
    }

    return null;
  }, [setIsOpen, openWindow, outboundUrlRef]);

  return (
    <Modal open={isOpen} callback={handlesUserDismiss} addClass="leave-site-modal" autoDismiss={15000}>
      <div className="modal-dialog">
        <h3>{title}</h3>
        <p>{subtitle}</p>
        <Button kind={ButtonKind.PRIMARY} size="small" click={() => confirm()}>
          Continue
        </Button>
      </div>
    </Modal>
  );
});

export default LeavingSite;
